import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { selectChapter, selectCourse, selectChapterLessons, selectHasChapterAccess } from '../redux/selectors';
import { completeChapter } from '../redux/actions';
import Icon from '../../../common/icons/Icon';

class Chapter extends Component {
  static propTypes = {
    canAccessChapter: PropTypes.bool.isRequired,
    chapter: PropTypes.object.isRequired,
    course: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    lessons: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { chapter, course, dispatch, history, lessons } = this.props;
    if (!chapter.complete) {
      const hasCompletedChapter = lessons.reduce((prev, curr) => (prev === false ? false : curr.complete), true);
      if (hasCompletedChapter) {
        dispatch(completeChapter(chapter.id)).then(() => {
          history.push(`/subscription/courses/${course.id}`);
        });
      }
    }
  }

  handleLessonLink = (status, e) => {
    if (status === 'locked') {
      e.preventDefault();
    }
  };

  handleThumbnailClick = (status, to, e) => {
    if (status !== 'locked') {
      e.stopPropagation();
      e.preventDefault();
      this.props.history.push(`${to}?autoplay`);
    }
  };

  renderHero = () => {
    const { course, lessons, match } = this.props;
    const chapterIndex = course.chapters.findIndex(chapter => chapter.id.toString() === match.params.chapterId);
    const chapter = course.chapters[chapterIndex];
    const lessonString = `${chapter.lessons} lesson${chapter.lessons === 1 ? '' : 's'}`;
    const quizString = `${chapter.quizzes} quiz${chapter.quizzes === 1 ? '' : 'zes'}`;
    const heroLesson = lessons.find(lesson => !lesson.complete);
    return (
      <div
        className={chapter.complete ? 'lesson__hero-wrapper lesson__hero-wrapper__with-status' : 'lesson__hero-wrapper'}
      >
        {chapter.complete ? (
          <div className="lesson__hero__status">
            <Icon icon="CheckmarkCircleOutline" />
            {`Congratulations on completing Chapter ${chapterIndex + 1} | ${chapter.name}`}
          </div>
        ) : null}
        <div className="container lesson-list__hero">
          <div className="lesson-list__hero__chapter-info">
            <Link to={`/subscription/courses/${course.id}`}>
              <span className="button__back-button">
                <Icon icon="BackArrow" />Back to {course.name}
              </span>
            </Link>
            <h1>
              Chapter {chapterIndex + 1} | {chapter.name}
            </h1>
            <em>
              {lessonString} | {quizString}
            </em>
            <p>{chapter.description}</p>
          </div>
          <div className="lesson-list__hero-card">
            {heroLesson ? this.renderLessonCard(heroLesson, 'current') : null}
          </div>
        </div>
      </div>
    );
  };

  // status === one of ["complete", "current", "locked"]
  renderLessonCard = (lesson, status) => {
    const { course, match } = this.props;
    const chapterIndex = course.chapters.findIndex(chapter => chapter.id.toString() === match.params.chapterId);
    const chapter = course.chapters[chapterIndex];

    let lessonStatusIcon = 'Lock';
    if (status === 'complete') {
      lessonStatusIcon = 'CheckmarkCircleOutline';
    } else if (status === 'current') {
      lessonStatusIcon = 'PlayCircle';
    }

    let lessonStatus = 'Locked';
    if (status === 'complete') {
      lessonStatus = 'Complete';
    } else if (status === 'current') {
      lessonStatus = '';
    }

    const to = `/subscription/courses/${course.id}/chapters/${chapter.id}/lessons/${lesson.id}`;

    return (
      <Link
        key={lesson.id}
        to={to}
        className={status === 'locked' ? 'lesson-card lesson-card--locked' : 'lesson-card'}
        onClick={this.handleLessonLink.bind(this, status)}
      >
        <div className="lesson-card__header">
          <h1>{lesson.name}</h1>
          <div className="lesson-card__header__status">
            <span>{lessonStatus}</span>
            <span onClick={this.handleThumbnailClick.bind(this, status, to)}>
              <Icon className={status === 'complete' ? 'icon--complete' : ''} icon={lessonStatusIcon} />
            </span>
          </div>
        </div>
        {lesson.video_sections.length !== 0 ? (
          <ul className="lesson-card__sections">
            {lesson.video_sections.slice(0, 3).map(section => (
              <li className="lesson-card__section" key={section.startTime}>
                {section.text}
              </li>
            ))}
          </ul>
        ) : null}
        <div
          onClick={this.handleThumbnailClick.bind(this, status, to)}
          className="lesson-card__image"
          style={{ backgroundImage: `url(${lesson.image.location})` }}
        >
          <Icon icon="PlayCircle" />
        </div>
      </Link>
    );
  };

  renderLessonList = () => {
    let current = false;
    return (
      <div className="lesson-list">
        {this.props.lessons.map(lesson => {
          let status = 'complete';

          if (!lesson.complete && !current) {
            status = 'current';
            current = true;
          } else if (!lesson.complete && current) {
            status = 'locked';
          }

          return this.renderLessonCard(lesson, status);
        })}
      </div>
    );
  };

  render() {
    const { canAccessChapter, course, chapter } = this.props;

    if (!canAccessChapter) {
      return <Redirect to={`/subscription/courses/${course.id}`} />;
    }
    const titleString = `${course.name} - Chapter ${course.chapters.findIndex(item => item.id === chapter.id) + 1}`;

    return (
      <div>
        <Helmet>
          <title>{titleString}</title>
        </Helmet>
        {this.renderHero()}
        {this.renderLessonList()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  canAccessChapter: selectHasChapterAccess(state, props),
  chapter: selectChapter(state, props),
  course: selectCourse(state, props),
  lessons: selectChapterLessons(state, props),
});

export default connect(mapStateToProps)(Chapter);



// WEBPACK FOOTER //
// ./src/subscription/courses/views/Chapter.js